import React from 'react'
import { Box } from '@mui/material'
import { formatPrice } from '@ui-seeker/utils'
import {tableColorsErrorRange, tableColorsMediumRange, tableColorsSuccessRange} from "../../@signals";


export default function priceColumn( firstThirdIndex, secondThirdIndex) {
	return {
		name: 'price', label: 'Price',
		options: {
			filter: false,
			customBodyRowRenderLite: (value, { id_master_currency_translation }, idx) =>
				<RealTimeTableDataPriceContent
					value={value}
					position={idx}
					currency={id_master_currency_translation}
					firstThirdIndex={firstThirdIndex}
					secondThirdIndex={secondThirdIndex}
				/>
		}
	}
}

const RealTimeTableDataPriceContent = props => {
	const {
		value,
		position,
		currency,
		firstThirdIndex,
		secondThirdIndex,
	} = props

	return <Box sx={{
		textAlign: 'center',
		...(position <= firstThirdIndex
				? tableColorsSuccessRange.value.getColor(Math.floor(value))
				: position >= firstThirdIndex && position <= secondThirdIndex
					? tableColorsMediumRange.value.getColor(value)
					: tableColorsErrorRange.value.getColor(value)
		),
		p: 1.5,
	}}>
		{formatPrice(value, currency)}
	</Box>
}